var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabPanel',{staticClass:"panel",attrs:{"value":"referrals"}},[_c('ReferralsTable',{staticStyle:{"margin-top":"0"},attrs:{"is-loading":_vm.isLoading,"data":_vm.referralData,"has-results":_vm.hasResults,"data-title":"Clicks","hide-unique":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }